import { render } from "./EditRoadWarrant.vue?vue&type=template&id=3f1fea81"
import script from "./EditRoadWarrant.vue?vue&type=script&lang=js"
export * from "./EditRoadWarrant.vue?vue&type=script&lang=js"
script.render = render

export default script